"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = exports.unit = exports.combat = undefined;

var _paths = require("./paths");

Object.keys(_paths).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paths[key];
    }
  });
});

var _selectors = require("../selectors");

var _selectors2 = _interopRequireDefault(_selectors);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require("reselect");

var paths = _interopRequireWildcard(_paths);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var combat = exports.combat = {
  data: function data(charId) {
    return paths.character.data(charId) + "/combat";
  },
  status: (0, _reselect.createSelector)(function (s) {
    return s.firebase;
  }, function (s, p) {
    return p.charId;
  }, function (firebase, charId) {
    var combat = _lodash2.default.get(firebase, ["data", "characters", charId, "combat"]);
    return combat == null ? "empty" : "done";
  })
};
// backward compatibility

var unit = exports.unit = {
  data: function data(charId, unitName) {
    return paths.character.data(charId) + "/unit/" + unitName;
  },
  status: function status(state, props) {
    var exists = _selectors2.default.unitTypes.isValidName(state, props);
    if (!exists) return "empty";
    var vis = _selectors2.default.chars2.units.isVisible(state, props);
    return vis ? "done" : "empty";
  }
};

var auth = exports.auth = {
  // TODO circular deps. after migrating to new loaders, this will go away
  status: function status(s, p) {
    return _selectors2.default.auth.loadStatus(s, p);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/firebase-connect/path-status.js
// module id = 854
// module chunks = 0